/* Yake — ürün sayfası: "Bedenimi Bul (AI)" + "Toptan Sipariş Formu"
   Sevim Burada'daki assets/bbg-pdp.js'in Concept portu (24 Eyl 2026).
   - Popup'lar native <dialog> (Sevim'de dialog-component idi)
   - Beden grubu Concept seçicisinden bulunur: .variant-input-wrapper[data-option-slug]
   - Varsayılan tablolar Sevim'deki büyük beden tablosu + altına XS/S/M (Yake'de normal bedenler de var)
   - Hesaplama (recommend / matchProductSize) Sevim'le birebir
   Klasik script, snippet'lerden defer ile yüklenir. */
(function () {
  if (window.__ykSevimPdpLoaded) return;
  window.__ykSevimPdpLoaded = true;

  /* ------------------------------------------------------------------ */
  /* Ortak: popup aç/kapat + seçili varyant                              */
  /* ------------------------------------------------------------------ */
  function openDialog(d) {
    if (!d || d.open) return;
    try { d.showModal(); } catch (e) { d.setAttribute('open', ''); }
    document.documentElement.classList.add('yk-sevim-lock');
  }
  function closeDialog(d) {
    if (!d) return;
    if (d.open) d.close();
    document.documentElement.classList.remove('yk-sevim-lock');
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[data-yk-open]');
    if (opener) {
      var d = document.getElementById(opener.getAttribute('aria-controls'));
      openDialog(d);
      return;
    }
    var closer = e.target.closest && e.target.closest('[data-yk-close]');
    if (closer) { closeDialog(closer.closest('dialog')); return; }
    /* perdeye (dialog'un kendisine) tıklayınca kapat */
    if (e.target.matches && e.target.matches('dialog.yk-sevim__dialog')) {
      var r = e.target.getBoundingClientRect();
      var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside) closeDialog(e.target);
    }
  });
  document.addEventListener('close', function (e) {
    if (e.target.matches && e.target.matches('dialog.yk-sevim__dialog')) document.documentElement.classList.remove('yk-sevim-lock');
  }, true);

  var currentVariant = null;

  function readVariantFromUrl() {
    try {
      var id = new URL(window.location.href).searchParams.get('variant');
      return id ? { id: id } : null;
    } catch (e) { return null; }
  }

  function variantTitleFromDom() {
    var parts = [], seen = {};
    document.querySelectorAll('variant-picker .variant-input-wrapper').forEach(function (opt) {
      var key = opt.getAttribute('data-option-slug') || ('idx' + parts.length);
      if (seen[key]) return;
      var checked = opt.querySelector('input[type="radio"]:checked');
      var sel = opt.querySelector('select');
      var v = checked ? checked.value : (sel ? sel.value : null);
      if (v) { parts.push(v); seen[key] = true; }
    });
    return parts.join(' / ');
  }

  /* Concept olayı productForm'a bubbles olmadan gönderiyor → yakalama aşamasında dinle */
  document.addEventListener('variant:change', function (e) {
    var v = e && e.detail && e.detail.variant;
    if (v) currentVariant = v;
    scheduleRefresh();
  }, true);

  /* ------------------------------------------------------------------ */
  /* 1) Toptan sipariş                                                   */
  /* ------------------------------------------------------------------ */
  function refreshWholesale() {
    document.querySelectorAll('[data-yk-wholesale]').forEach(function (comp) {
      var vt = (currentVariant && currentVariant.title && currentVariant.title !== 'Default Title')
        ? currentVariant.title : variantTitleFromDom();
      var sku = currentVariant && currentVariant.sku ? currentVariant.sku : null;
      var vField = comp.querySelector('[data-yk-field="variant"]');
      var sField = comp.querySelector('[data-yk-field="sku"]');
      var uField = comp.querySelector('[data-yk-field="url"]');
      var vLabel = comp.querySelector('[data-yk-variant-label]');
      var sLabel = comp.querySelector('[data-yk-variant-sku]');
      if (vt) {
        if (vField) vField.value = vt;
        if (vLabel) vLabel.textContent = vt;
      }
      if (sku !== null) {
        if (sField) sField.value = sku;
        if (sLabel) sLabel.textContent = sku;
      }
      if (uField && currentVariant && currentVariant.id) {
        try {
          var u = new URL(uField.value || location.href, location.origin);
          u.searchParams.set('variant', currentVariant.id);
          uField.value = u.toString();
        } catch (e) { /* sessiz */ }
      }
    });
  }

  /* 29 Eyl 2026: para biçimi (Shopify money_format) */
  function formatMoney(cents, fmt) {
    var n = (Number(cents) || 0) / 100;
    function grp(num, dec, thou, decSep) {
      var p = num.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return p[1] ? p[0] + decSep + p[1] : p[0];
    }
    fmt = fmt || '{{amount}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount', val;
    switch (key) {
      case 'amount_no_decimals': val = grp(n, 0, ',', '.'); break;
      case 'amount_with_comma_separator': val = grp(n, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = grp(n, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = grp(n, 2, "'", '.'); break;
      default: val = grp(n, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, val);
  }

  /* Seri içeriği: "S1-M2-L1", "XS1 S2 M2 L1", "362-382-402" (son hane adet) → [{size, qty}] */
  function parseSeries(raw) {
    if (!raw) return [];
    var out = [];
    var toks = String(raw).toUpperCase().split(/[\s,;\-\/]+/).filter(Boolean);
    /* yalnız bedenler yazılmışsa (36-38-40) her beden 1 adet */
    if (toks.length && toks.every(function (t) { return /^\d{2}$/.test(t); })) {
      return toks.map(function (t) { return { size: t, qty: 1 }; });
    }
    toks.forEach(function (tok) {
      tok = tok.replace(/[^0-9A-Z:×X*]/g, '');
      if (!tok) return;
      var m = tok.match(/^(.+?)[:×*](\d+)$/) || tok.match(/^(\d*[A-Z]+)(\d+)$/);
      var size, qty;
      if (m) { size = m[1]; qty = parseInt(m[2], 10); }
      else if (/^\d{2,}$/.test(tok)) { size = tok.slice(0, -1); qty = parseInt(tok.slice(-1), 10); }
      if (size && qty > 0) out.push({ size: size, qty: qty });
    });
    return out;
  }

  function refreshSeries(comp) {
    var info = comp.querySelector('[data-yk-ws-info]');
    if (!info) return;
    var parts = parseSeries(info.getAttribute('data-series'));
    var row = info.querySelector('[data-yk-series-row]');
    var priceRow = info.querySelector('[data-yk-series-price-row]');
    if (!parts.length) { if (row) row.hidden = true; if (priceRow) priceRow.hidden = true; return; }
    var total = parts.reduce(function (a, p) { return a + p.qty; }, 0);
    var unit = currentVariant && currentVariant.price != null ? currentVariant.price : info.getAttribute('data-unit-price');
    info.querySelector('[data-yk-series-text]').textContent =
      parts.map(function (p) { return p.size + ' ×' + p.qty; }).join(' · ') + ' (' + total + ' adet)';
    info.querySelector('[data-yk-series-price]').textContent =
      formatMoney(Number(unit) * total, info.getAttribute('data-money-format'));
    row.hidden = false; priceRow.hidden = false;
  }

  function wholesaleTotals(comp) {
    var total = 0, dist = [];
    comp.querySelectorAll('[data-yk-variant-qty]').forEach(function (inp) {
      var n = Math.max(0, parseInt(inp.value, 10) || 0);
      if (n > 0) { total += n; dist.push(inp.getAttribute('data-variant-title') + ' ×' + n); }
    });
    return { total: total, dist: dist.join(', ') };
  }

  function initWholesale(comp) {
    if (comp.__ykInit) return;
    comp.__ykInit = true;
    var qty = comp.querySelector('[data-yk-qty]');
    var minNote = comp.querySelector('[data-yk-min-note]');
    var totalEl = comp.querySelector('[data-yk-total]');
    var distField = comp.querySelector('[data-yk-field="dist"]');
    var minWholesale = qty ? parseInt(qty.getAttribute('data-min-wholesale') || '1', 10) : 1;
    var isWholesale = function () {
      var r = comp.querySelector('[data-yk-order-type]:checked');
      return !r || r.value.toLowerCase().indexOf('toptan') > -1;
    };
    function sync() {
      var t = wholesaleTotals(comp);
      if (qty) qty.value = String(t.total);
      if (distField) distField.value = t.dist;
      if (totalEl) totalEl.textContent = String(t.total);
      var low = isWholesale() && t.total < minWholesale;
      comp.classList.toggle('yk-ws--below-min', low);
      if (minNote) minNote.hidden = !isWholesale();
    }
    comp.addEventListener('input', function (e) { if (e.target.matches('[data-yk-variant-qty]')) sync(); });
    comp.querySelectorAll('[data-yk-order-type]').forEach(function (r) { r.addEventListener('change', sync); });
    refreshSeries(comp);
    sync();
    var form = comp.querySelector('form');
    if (form) {
      form.addEventListener('submit', function (ev) {
        sync();
        var t = wholesaleTotals(comp);
        var need = isWholesale() ? minWholesale : 1;
        if (t.total < need) {
          ev.preventDefault();
          var first = comp.querySelector('[data-yk-variant-qty]');
          if (first) {
            first.setCustomValidity(isWholesale() ? 'Toptan siparişte toplam en az ' + minWholesale + ' adet olmalı.' : 'En az 1 adet seçin.');
            first.reportValidity();
            setTimeout(function () { first.setCustomValidity(''); }, 2500);
          }
          return;
        }
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
      });
    }
    /* Gönderim sonrası (başarı/hata) popup'ı otomatik aç */
    if (comp.querySelector('[data-yk-open-dialog]')) {
      openDialog(comp.querySelector('dialog'));
    }
  }

  /* ------------------------------------------------------------------ */
  /* 1b) WhatsApp'tan sipariş (29 Eyl 2026)                              */
  /* ------------------------------------------------------------------ */
  /* Adet: butonun bulunduğu bölümdeki ürün formunun adet alanı (10 Eki 2026) */
  function qtyFor(a) {
    var scope = a.closest('.shopify-section') || document;
    var q = scope.querySelector('product-form input[name="quantity"], form[action*="/cart/add"] input[name="quantity"], input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : NaN;
    return String(isNaN(n) || n < 1 ? 1 : n);
  }

  function refreshWhatsapp() {
    document.querySelectorAll('[data-yk-whatsapp]').forEach(function (a) {
      var vt = (currentVariant && currentVariant.title && currentVariant.title !== 'Default Title')
        ? currentVariant.title : variantTitleFromDom();
      var url = a.getAttribute('data-product-url');
      var vid = (currentVariant && currentVariant.id) || a.getAttribute('data-variant-id');
      if (vid) {
        try { var u = new URL(url); u.searchParams.set('variant', vid); url = u.toString(); } catch (e) { /* sessiz */ }
      }
      var price = currentVariant && currentVariant.price != null
        ? formatMoney(currentVariant.price, a.getAttribute('data-money-format')) : (a.getAttribute('data-price') || null);
      var msg = (a.getAttribute('data-template') || '')
        .split('[product]').join(a.getAttribute('data-product-title') || '')
        .split('[variant]').join(vt || '')
        .split('[url]').join(url)
        .split('[qty]').join(qtyFor(a));
      if (price) msg = msg.split('[price]').join(price);
      else if (msg.indexOf('[price]') > -1) return; /* fiyat bilinmiyorsa Liquid'in linki kalsın */
      a.href = 'https://wa.me/' + a.getAttribute('data-phone') + '?text=' + encodeURIComponent(msg);
    });
  }

  /* ------------------------------------------------------------------ */
  /* 2) Bedenimi Bul                                                     */
  /* ------------------------------------------------------------------ */
  /* Sevim'in büyük beden tabloları (cm) + altına XS/S/M. tr: Türk beden karşılığı. */
  var CHART_WOMEN = [
    { size: 'XS',  tr: '34',    bust: [76, 80],   waist: [58, 62],   hips: [84, 88] },
    { size: 'S',   tr: '36',    bust: [80, 84],   waist: [62, 66],   hips: [88, 92] },
    { size: 'M',   tr: '38',    bust: [84, 92],   waist: [66, 76],   hips: [92, 100] },
    { size: 'L',   tr: '40-42', bust: [92, 100],  waist: [76, 84],   hips: [100, 108] },
    { size: 'XL',  tr: '44-46', bust: [100, 108], waist: [84, 92],   hips: [108, 116] },
    { size: '2XL', tr: '48-50', bust: [108, 116], waist: [92, 100],  hips: [116, 124] },
    { size: '3XL', tr: '52-54', bust: [116, 124], waist: [100, 108], hips: [124, 132] },
    { size: '4XL', tr: '56-58', bust: [124, 132], waist: [108, 116], hips: [132, 140] },
    { size: '5XL', tr: '60-62', bust: [132, 140], waist: [116, 124], hips: [140, 148] },
    { size: '6XL', tr: '64-66', bust: [140, 148], waist: [124, 132], hips: [148, 156] },
    { size: '7XL', tr: '68-70', bust: [148, 156], waist: [132, 140], hips: [156, 164] },
    { size: '8XL', tr: '72-74', bust: [156, 164], waist: [140, 148], hips: [164, 172] }
  ];
  var CHART_MEN = [
    { size: 'S',   tr: '46',    bust: [88, 94],   waist: [76, 82],   hips: [90, 96] },
    { size: 'M',   tr: '48-50', bust: [94, 100],  waist: [82, 88],   hips: [96, 102] },
    { size: 'L',   tr: '52',    bust: [100, 106], waist: [88, 94],   hips: [102, 108] },
    { size: 'XL',  tr: '54-56', bust: [106, 114], waist: [94, 102],  hips: [108, 114] },
    { size: '2XL', tr: '58-60', bust: [114, 122], waist: [102, 110], hips: [114, 120] },
    { size: '3XL', tr: '62-64', bust: [122, 130], waist: [110, 118], hips: [120, 126] },
    { size: '4XL', tr: '66-68', bust: [130, 138], waist: [118, 126], hips: [126, 132] },
    { size: '5XL', tr: '70-72', bust: [138, 146], waist: [126, 134], hips: [132, 138] },
    { size: '6XL', tr: '74-76', bust: [146, 154], waist: [134, 142], hips: [138, 144] },
    { size: '7XL', tr: '78-80', bust: [154, 162], waist: [142, 150], hips: [144, 150] },
    { size: '8XL', tr: '82-84', bust: [162, 170], waist: [150, 158], hips: [150, 156] }
  ];

  var STORAGE_KEY = 'yk:size-finder';

  function pickChart(comp) {
    var raw = comp.getAttribute('data-chart');
    if (raw) {
      try {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length && parsed[0].size) return parsed;
      } catch (e) { console.warn('[Yake size-finder] size_chart_json okunamadı:', e); }
    }
    var g = comp.getAttribute('data-gender') || 'auto';
    if (g === 'men') return CHART_MEN;
    if (g === 'women') return CHART_WOMEN;
    var hint = ((comp.getAttribute('data-product-type') || '') + ' ' + document.title + ' ' + (comp.closest('.product__info, main') || document.body).textContent.slice(0, 400)).toLocaleLowerCase('tr');
    if (/\berkek\b|\bman\b|\bmen\b|\bbay\b/.test(hint) && !/kadın|kadin|women|bayan/.test(hint)) return CHART_MEN;
    return CHART_WOMEN;
  }

  function estimateMeasures(h, w, isMen) {
    var bmi = w / Math.pow(h / 100, 2);
    var bust, waist, hips;
    if (isMen) {
      bust = 42.5 + bmi * 2.3;
      waist = 32.5 + bmi * 2.3;
      hips = 64 + bmi * 1.6;
    } else {
      bust = 44 + bmi * 2.0;
      waist = 20.5 + bmi * 2.25;
      hips = 52 + bmi * 2.0;
    }
    var hAdj = (h - 165) * 0.08;
    return { bust: bust + hAdj, waist: waist + hAdj, hips: hips + hAdj, bmi: bmi };
  }

  function mid(r) { return (r[0] + r[1]) / 2; }

  function scoreRow(row, m, weights) {
    var s = 0, tw = 0;
    ['bust', 'waist', 'hips'].forEach(function (k) {
      if (!row[k] || m[k] == null) return;
      var d = Math.abs(m[k] - mid(row[k])) / Math.max(1, (row[k][1] - row[k][0]));
      s += d * weights[k]; tw += weights[k];
    });
    return tw ? s / tw : 999;
  }

  function recommend(chart, input, isMen) {
    var est = estimateMeasures(input.height, input.weight, isMen);
    var m = {
      bust: input.bust || est.bust,
      waist: input.waist || est.waist,
      hips: input.hips || est.hips
    };
    var weights = {
      bust: input.bust ? 1.6 : 1,
      waist: input.waist ? 1.4 : 1,
      hips: input.hips ? 1.4 : 1
    };
    var scored = chart.map(function (row, i) { return { i: i, row: row, s: scoreRow(row, m, weights) }; });
    scored.sort(function (a, b) { return a.s - b.s; });
    var best = scored[0], idx = best.i;
    if (input.fit === 'loose' && idx < chart.length - 1) {
      idx = Math.min(chart.length - 1, idx + 1);
    } else if (input.fit === 'slim' && idx > 0 && best.s < 0.25) {
      idx = Math.max(0, idx - (best.s < 0.12 ? 1 : 0));
    }
    var confidence = best.s < 0.35 ? 'high' : (best.s < 0.75 ? 'medium' : 'low');
    var hasRealMeasures = !!(input.bust || input.waist || input.hips);
    return { index: idx, row: chart[idx], alt: chart[Math.min(chart.length - 1, idx + 1)], confidence: confidence, estimated: !hasRealMeasures, measures: m };
  }

  function parseSizeToken(v) {
    var t = String(v).trim().toLocaleUpperCase('tr').replace(/İ/g, 'I').replace(/\s+/g, '');
    var m;
    if ((m = t.match(/^([0-9]{1,2})XL$/))) return { kind: 'xl', n: parseInt(m[1], 10) };
    if (t === 'XL') return { kind: 'xl', n: 1 };
    if ((m = t.match(/^X{2,}L$/))) return { kind: 'xl', n: t.length - 1 };
    if (t === 'L') return { kind: 'xl', n: 0 };
    if (t === 'M') return { kind: 'xl', n: -1 };
    if (t === 'S') return { kind: 'xl', n: -2 };
    if (t === 'XS') return { kind: 'xl', n: -3 };
    if ((m = t.match(/^([0-9]{2,3})(?:[-\/–]([0-9]{2,3}))?/))) {
      var a = parseInt(m[1], 10), b = m[2] ? parseInt(m[2], 10) : a;
      return { kind: 'tr', n: (a + b) / 2, lo: a, hi: b };
    }
    return null;
  }

  function rowXlIndex(row) {
    var p = parseSizeToken(row.size);
    return p && p.kind === 'xl' ? p.n : null;
  }
  function rowTrMid(row) {
    if (!row.tr) return null;
    var p = parseSizeToken(String(row.tr));
    return p && p.kind === 'tr' ? p.n : null;
  }

  function matchProductSize(values, rec) {
    if (!values || !values.length) return null;
    var targetXl = rowXlIndex(rec.row);
    var targetTr = rowTrMid(rec.row);
    var best = null, bestD = Infinity;
    values.forEach(function (v) {
      var p = parseSizeToken(v);
      if (!p) return;
      var d;
      if (p.kind === 'xl' && targetXl != null) d = Math.abs(p.n - targetXl);
      else if (p.kind === 'tr' && targetTr != null) d = Math.abs(p.n - targetTr) / 2;
      else return;
      if (d < bestD) { bestD = d; best = v; }
    });
    return best ? { value: best, exact: bestD < 0.75 } : null;
  }

  /* Concept: <variant-picker> içinde .variant-input-wrapper[data-option-slug] (buton: radio, açılır: select) */
  function findSizeInput(value, optionIndex) {
    var groups = Array.prototype.slice.call(document.querySelectorAll('variant-picker .variant-input-wrapper'));
    var group = null;
    groups.forEach(function (g) {
      var t = (g.getAttribute('data-option-slug') || '').toLocaleLowerCase('tr');
      if (!group && (t.indexOf('beden') > -1 || t.indexOf('size') > -1 || t.indexOf('numara') > -1)) group = g;
    });
    if (!group && optionIndex >= 0 && groups[optionIndex]) group = groups[optionIndex];
    if (!group) return null;
    var norm = function (s) { return String(s).trim().toLocaleUpperCase('tr').replace(/\s+/g, ''); };
    var input = null;
    group.querySelectorAll('input[type="radio"]').forEach(function (i) { if (!input && norm(i.value) === norm(value)) input = i; });
    if (input) return { type: 'radio', el: input };
    var sel = group.querySelector('select');
    if (sel) {
      var opt = Array.prototype.find.call(sel.options, function (o) { return norm(o.value) === norm(value); });
      if (opt) return { type: 'select', el: sel, value: opt.value };
    }
    return null;
  }

  function initSizeFinder(comp) {
    if (comp.__ykInit) return;
    comp.__ykInit = true;
    var form = comp.querySelector('[data-yk-size-form]');
    var result = comp.querySelector('[data-yk-size-result]');
    var errEl = comp.querySelector('[data-yk-size-error]');
    var primary = comp.querySelector('[data-yk-size-primary]');
    var secondary = comp.querySelector('[data-yk-size-secondary]');
    var note = comp.querySelector('[data-yk-size-note]');
    var applyBtn = comp.querySelector('[data-yk-size-apply]');
    var resetBtn = comp.querySelector('[data-yk-size-reset]');
    if (!form || !result) return;

    var sizeValues = (comp.getAttribute('data-size-values') || '').split('|').filter(Boolean);
    var optionIndex = parseInt(comp.getAttribute('data-size-option-index') || '-1', 10);
    var chart = pickChart(comp);
    var isMen = chart === CHART_MEN;

    try {
      var saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (saved) Object.keys(saved).forEach(function (k) { var f = form.elements[k]; if (f && saved[k]) f.value = saved[k]; });
    } catch (e) { /* sessiz */ }

    var lastMatch = null;
    function setBtnText(btn, text) { var s = btn.querySelector('.btn-text') || btn; s.textContent = text; }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      errEl.hidden = true;
      var input = {
        height: parseFloat(form.elements.height.value),
        weight: parseFloat(form.elements.weight.value),
        bust: parseFloat(form.elements.bust.value) || 0,
        waist: parseFloat(form.elements.waist.value) || 0,
        hips: parseFloat(form.elements.hips.value) || 0,
        fit: form.elements.fit.value || 'regular'
      };
      if (!(input.height >= 130 && input.height <= 220) || !(input.weight >= 40 && input.weight <= 250)) {
        errEl.textContent = 'Lütfen boy (130-220 cm) ve kilo (40-250 kg) bilgilerinizi kontrol edin.';
        errEl.hidden = false;
        return;
      }
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(input)); } catch (e) { /* sessiz */ }

      var rec = recommend(chart, input, isMen);
      var match = matchProductSize(sizeValues, rec);
      lastMatch = match;

      var label = rec.row.size + (rec.row.tr ? ' (' + rec.row.tr + ')' : '');
      if (match) {
        primary.textContent = match.value;
        secondary.textContent = match.exact ? ('Tablo karşılığı: ' + label) : ('Tabloya göre ' + label + ' — bu üründe en yakın seçenek: ' + match.value);
      } else {
        primary.textContent = rec.row.size;
        secondary.textContent = rec.row.tr ? ('Türk bedeni: ' + rec.row.tr) : '';
      }

      var msgs = [];
      if (rec.estimated) msgs.push('Göğüs/bel/kalça ölçünüzü de girerseniz öneri daha isabetli olur.');
      if (rec.confidence === 'low') msgs.push('Ölçüleriniz iki beden arasında; rahat kalıp için ' + rec.alt.size + ' bedenini de değerlendirin.');
      else if (rec.confidence === 'medium') msgs.push('Alternatif: ' + rec.alt.size + (rec.alt.tr ? ' (' + rec.alt.tr + ')' : ''));
      note.textContent = msgs.join(' ');

      var target = match ? findSizeInput(match.value, optionIndex) : null;
      if (applyBtn) {
        applyBtn.hidden = !target;
        setBtnText(applyBtn, target ? ('Bu Bedeni Seç: ' + match.value) : 'Bu Bedeni Seç');
      }
      form.hidden = true;
      result.hidden = false;
      comp.dispatchEvent(new CustomEvent('yk:size-recommended', { bubbles: true, detail: { recommendation: rec, match: match } }));
    });

    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        if (!lastMatch) return;
        var target = findSizeInput(lastMatch.value, optionIndex);
        if (!target) return;
        if (target.type === 'radio') {
          target.el.click();
          target.el.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          target.el.value = target.value;
          target.el.dispatchEvent(new Event('change', { bubbles: true }));
        }
        closeDialog(comp.querySelector('dialog'));
      });
    }
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        result.hidden = true;
        form.hidden = false;
        var first = form.querySelector('input');
        if (first) first.focus();
      });
    }
  }

  /* ------------------------------------------------------------------ */
  /* Başlatma                                                            */
  /* ------------------------------------------------------------------ */
  var refreshTimer = null;
  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      refreshWholesale();
      refreshWhatsapp();
      document.querySelectorAll('[data-yk-wholesale]').forEach(refreshSeries);
    }, 60);
  }

  function initAll() {
    document.querySelectorAll('[data-yk-wholesale]').forEach(initWholesale);
    document.querySelectorAll('[data-yk-size-finder]').forEach(initSizeFinder);
    if (!currentVariant) currentVariant = readVariantFromUrl();
    scheduleRefresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  /* Varyant değişiminde bölüm yeniden çizilirse yeni bloklar gelir */
  var initTimer = null;
  new MutationObserver(function () { clearTimeout(initTimer); initTimer = setTimeout(initAll, 120); })
    .observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-picker')) scheduleRefresh();
    else if (e.target && e.target.name === 'quantity') scheduleRefresh();
  });
  document.addEventListener('input', function (e) {
    if (e.target && e.target.name === 'quantity' && document.querySelector('[data-yk-whatsapp]')) scheduleRefresh();
  });
})();
